export default __webpack_public_path__ + "static/media/purchase.5b15f6a6.svg";